/*
	Device detection

	Note: Normally device detection is considered "bad", as browser feature detection is preferred, however in this case, we're using the detection to work around issues that cannot be detected in other ways, so it is ok.
*/
const ua = global.navigator.userAgent || global.navigator.vendor || global.opera

//	Ref: https://supergeekery.com/blog/detecting-the-instagram-in-app-browser
const isInstagram = () => ua.indexOf('Instagram') > -1

//	Ref: https://stackoverflow.com/a/9039885/6637365
const isIos = () => !!/iPhone|iPod|iPad/g.test(ua) && !global.MSStream

//	Ref: https://stackoverflow.com/a/41749865/6637365
const isPwa = () => !!global.matchMedia('(display-mode: standalone)').matches

export default {
	isInstagram,
	isIos,
	isPwa
}



// WEBPACK FOOTER //
// ./src/utilities/deviceDetect.js